import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Loader from '../components/loader';

function App() {
  const [reciepts, setReciepts] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [reportType, setReportType] = useState(false); // true for Party, false for Transaction
  const [loading, setLoading] = useState(false);
  
  console.log(reciepts);

  const months = Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString("default", { month: "long" })
  );

  const fetchDateData = async () => {
    setLoading(true);
    const sendData = {
      year: year,
      month: month
    };
    try {
      const response = await axios.post('https://api.trucoo.in/receipts/', sendData, {
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': 'erpTrucoo'
      }});

      // console.log(response?.data);

      if(response?.data?.data?.length > 0){
        setReciepts(response?.data?.data);
      }else{
        setReciepts([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDateData();
  }, [year, month]);

  useEffect(() => {
    const totalAmount = reciepts?.reduce((sum, payment) => sum + Number(payment.receipt_amount || 0), 0);
    setTotalAmount(totalAmount);
  }, [year, month, reciepts]);

  const groupByPartyCode = (data) => {
    const grouped = {};

    data.forEach((item) => {
      const code = item.party_code;

      if (!grouped[code]) {
        grouped[code] = {
          party: item.party_name,
          party_code: code,
          transactions: [],
          payment: 0,
        };
      }

      grouped[code].transactions.push({
        id: item.id,
        master: item.master,
        mainGroup: item.mainGroup,
        subGroup: item.subGroup,
        subGroupName: item.subGroupName,
        date: item.date,
        receipt_amount: item.receipt_amount,
        credit_ac_name: item.credit_ac_name,
        narration: item.narration,
        deleted: item.deleted,
      });

      grouped[code].payment += Number(item.receipt_amount);
    });

    return Object.values(grouped);
  };

  useEffect(() => {
    setGroupedData(groupByPartyCode(reciepts));
  }, [reciepts]);

  // console.log('Reciepts:', groupedData);

  return (
    <>
     {loading && <Loader />}
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="col-12">
              <div className="box">
                <div className="box-header with-border">
                   <h4 className="box-title">Payment Receive</h4>
                   <div className="box-tools pull-right">
                    <div className='flex gap-2'>
                      <p className='mt-2' style={{minWidth: '400px'}}>Payment for {year} {month && month !== 'all' ? new Date(0, month - 1).toLocaleString("default", { month: "long" }) : ''} is <span className='text-bold'>{Number(totalAmount).toFixed(2)}</span></p>
                      <select value={year} onChange={(e) => setYear(e.target.value)} className='form-select' style={{minWidth: '90px'}}>
                        <option value="all">All Years</option>
                        {Array.from(
                          { length: currentYear - 2023 + 1 },
                          (_, i) => currentYear - i
                        ).map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}

                      </select>
                      {year !== 'all' && (
                        <select value={month} onChange={(e) => setMonth(Number(e.target.value))} className='form-select' style={{minWidth: '120px'}}>
                          <option value="all">All Months</option>
                          {months.map((month, index) => (
                            <option key={index} value={index + 1}>
                              {month}
                            </option>
                          ))}
                        </select>
                      )}
                      <div className="form-group" style={{minWidth: '150px', marginBottom: '0'}}>
                        <div className="input-group">
                          <button className={`btn btn-sm  ${!reportType ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setReportType(false)}>Transaction</button>
                          <button className={`btn btn-sm  ${reportType ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setReportType(true)}>Party</button>
                        </div>
                      </div>
                    </div>
                   </div>
                </div>
                <div className="box-body">
                  
                  <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 270px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                    <table className="table-sm fs-12 text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                      <thead>
                         <tr className="text-dark text-center" style={{ position: 'sticky', top: -1, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                          <th className='text-center'>S.No</th>
                          <th>Date</th>
                          <th>Party</th>
                          <th>Ledger</th>
                          <th className='text-end'>Amount</th>
                          <th>Ref.No</th>
                          <th>Narration</th>
                        </tr>
                      </thead>
                      <tbody>
                        
                        {!reportType ?
                          reciepts?.length > 0 ?
                            reciepts?.map((payment, index) => (
                              <tr key={payment.client_id}>
                                <td className='text-center'>{index + 1}</td>
                                <td>{payment.date}</td>
                                <td>{payment.party_name}</td>
                                <td>{payment.subGroupName}</td>
                                <td className='text-end'>{payment.receipt_amount	}</td>
                                <td>{payment.credit_ac_name}</td>
                                <td>{payment.narration}</td>
                              </tr>
                            ))
                          :
                            <tr>
                              <td colSpan="6" className="text-center">No records found</td>
                            </tr>
                        : groupedData?.length > 0 ?
                          groupedData?.map((group, groupIndex) => (
                            <React.Fragment key={group.party_code}>
                              <tr className="bg-light">
                                <td colSpan={6} className="text-dark text-bold">
                                  {groupIndex + 1}. {group.party} (Code: {group.party_code}) - Total Payment: {Number(group.payment).toFixed(2)}
                                </td>
                              </tr>
                              {group.transactions.map((transaction, transactionIndex) => (
                                <tr key={transaction.id}>
                                  <td className='text-center'>{transactionIndex + 1}</td>
                                  <td>{transaction.date}</td>
                                  <td>{group.party}</td>
                                  <td>{transaction.subGroupName}</td>
                                  <td className='text-end'>{transaction.receipt_amount}</td>
                                  <td>{transaction.credit_ac_name}</td>
                                  <td>{transaction.narration}</td>
                                </tr>
                              ))}
                            </React.Fragment>
                          ))
                        :
                          <tr>
                            <td colSpan="6" className="text-center">No records found</td>
                          </tr>
                        }
                        <tr
                          className="text-dark"
                          style={{
                            position: "sticky",
                            bottom: -11,
                            zIndex: 2,
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          <th colSpan={3}>Total</th>
                          <th className="text-end">{Number(totalAmount).toFixed(2)}</th>
                          <th colSpan={2}></th>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default App;
